import { LoadingOutlined } from '@ant-design/icons'
import { Button, Input, Result, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../../services/backend'
import { TuloposApiCredentials } from '../../types'
import { notificationAction } from '../../../../../../redux/middleware/actions'
import { AppDispatch } from '../../../../../../redux/store'
import DataUpdate from '../../dataUpdate'

const TuloposApi: React.FC = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)
  const getCredentials = useBackend(`/tulopos/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const setCredentials = useBackend(`/tulopos/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)

  const dispatch: AppDispatch = useDispatch()

  const [username, setUsername] = useState<string>()
  const [password, setPassword] = useState<string>()
  const [authorized, setAuthorized] = useState(false)

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then((credentials: TuloposApiCredentials) => {
        setUsername(credentials.username)
        setPassword(credentials.password)
        if (credentials.username && credentials.password) {
          setAuthorized(true)
        } else {
          setUsername('')
          setPassword('')
          setAuthorized(false)
        }
      })
      .catch(() => {
        setUsername('')
        setPassword('')
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  const submit = () => {
    setCredentials
      .put({
        urlParams: { companyId },
        body: {
          data: {
            username,
            password
          }
        }
      })
      .then((credentials: TuloposApiCredentials) => {
        setUsername(credentials.username)
        setPassword(credentials.password)
        setAuthorized(true)
        dispatch(
          notificationAction({
            type: 'success',
            message: 'AUTHENTICATION_SUCCESS',
            description: 'IMPORT_SUCCESS_EMAIL'
          })
        )
      })
      .catch(() => {
        setAuthorized(false)
        dispatch(
          notificationAction({
            type: 'error',
            message: 'AUTHENTICATION_ERROR',
            description: 'USERNAME_PASSWORD_MISMATCH'
          })
        )
      })
  }

  const emptyCredentials = () => {
    setUsername('')
    setPassword('')
    setAuthorized(false)
  }

  if (authorized) {
    return (
      <>
        <Result
          status="success"
          title={t('integrationsPage:authenticated')}
          extra={
            <>
              <Button onClick={emptyCredentials} type="primary">
                {t('integrationsPage:authenticate')}
              </Button>
              <DataUpdate page="tulopos" />
            </>
          }
        />
      </>
    )
  }
  return (
    <Form layout="vertical">
      <Form.Item style={{ marginTop: 10 }} label={t('integrationsPage:username')}>
        <Input
          value={username}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item label={t('integrationsPage:password')}>
        <Input
          value={password}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <Button.Group>
          <Button type="primary" onClick={() => submit()} loading={setCredentials.loading}>
            {t('integrationsPage:authenticate')}
          </Button>
        </Button.Group>
      </Form.Item>
    </Form>
  )
}

export default TuloposApi
